import { observeRequest } from 'front-end-core/helpers/api'

const fcObserveRequest = observeRequest({ forbiddenAllowed: true })

export default fcObserveRequest
